export const getPwaUrlForOnboarding = (): string => {
  const { origin, pathname } = window.location;

  // STAGE
  if (
    origin === 'https://stage.ravelo.pro'
  ) {
    return 'https://stage-app.ravelo.pro';
  }

  // PROD
  if (
    origin === 'https://quiz.ravelo.pro'
  ) {
    return 'https://app.ravelo.pro';
  }

  return 'https://stage-app.ravelo.pro';
};
